import { ActionTypes } from "./plan-editor.actions";
import { Action } from "@ngrx/store";
import { Patient } from "../patient/patient.model";

export interface State {
  planId: string;
  planName: string;
  patient: Patient;
}

export const initialState: State = {
  planId: null,
  planName: null,
  patient: null,
};

export function reducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case ActionTypes.LOAD_SUCCESS:
      return Object.assign({}, state, {
        planId: action.payload.id,
        planName: action.payload.name,
        patient: action.payload.patient,
      });

    case ActionTypes.CHANGE_NAME_SUCCESS:
      return Object.assign({}, state, { planName: action.payload.name });

    default:
      return state;
  }
}

export const getPlanId = (state: State) => state.planId;
export const getPlanName = (state: State) => state.planName;
export const getPatient = (state: State) => state.patient;



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan-editor.reducer.ts